
export const VIDEO_LINK = {
    URL : "https://ix-website.s3.amazonaws.com/webinar-videos/"
}